var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 11.9817H7.125C3.29688 11.9817 0.25 15.0676 0.25 18.8567C0.25 19.5598 0.796875 20.1067 1.5 20.1067H16.5C17.1641 20.1067 17.75 19.5598 17.75 18.8567C17.75 15.0676 14.6641 11.9817 10.875 11.9817ZM2.125 18.2317C2.4375 15.7708 4.54688 13.8567 7.125 13.8567H10.875C13.4141 13.8567 15.5234 15.7708 15.8359 18.2317H2.125ZM9 10.1067C11.7344 10.1067 14 7.88013 14 5.10669C14 2.37231 11.7344 0.106689 9 0.106689C6.22656 0.106689 4 2.37231 4 5.10669C4 7.88013 6.22656 10.1067 9 10.1067ZM9 1.98169C10.7188 1.98169 12.125 3.38794 12.125 5.10669C12.125 6.8645 10.7188 8.23169 9 8.23169C7.24219 8.23169 5.875 6.8645 5.875 5.10669C5.875 3.38794 7.24219 1.98169 9 1.98169Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.1438d87ecfc540a0e30ddb52373feef3.svg";
export { ForwardRef as ReactComponent };